'use strict';

angular.module('pmtPlacesApp.filters').filter('formatDistance', function () {

	return function (input) {
		if (input == null || Number.isNaN(input)) {
			return '-';
		} else if (input > 1000) {
			return Math.round(input / 1000) + ' km';
		} else {
			return Math.round(input) + ' m';
		}
	};
});
